@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">

  <!-- Formulário aparece apenas quando não há resultados carregados e não está carregando -->
  <div *ngIf="(editingMode || !resultTest) && !isLoading" style="text-align: left; width: 100%">

    <!-- Active Filters Counter -->
    <div *ngIf="activeFilters.length > 0" style="margin-bottom: 16px;">
      <app-active-filters-counter
        [filters]="activeFilters"
        (filterRemoved)="onFilterRemoved($event)"
        (filterClicked)="onFilterClicked($event)"
        (clearAllClicked)="onClearAllFilters()">
      </app-active-filters-counter>
    </div>

    <form [formGroup]="searchForm">

      <!-- Seção: Informações Profissionais -->
      <div class="form-section">
        <h3>Informações Profissionais</h3>

        <div class="multiColumns">
          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Conselho
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Selecione o conselho profissional (ex: CRM, CRO, CRF). Este campo é obrigatório para realizar a busca."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <mat-select formControlName="councilGroup">
                <mat-option *ngFor="let council of councilGroupEnum | keyvalue" [value]="council.key">
                  <span style="font-weight: 600">{{ council.key }}</span> - {{ council.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Profissão
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Selecione a profissão desejada. A lista é filtrada com base no conselho selecionado."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <mat-select formControlName="professionName">
                <mat-option *ngFor="let profession of getProfessionName()" [value]="profession">{{ profession
                  }}</mat-option>
              </mat-select>
              <mat-icon matSuffix *ngIf="showSuccess('professionName')" class="success-icon">check_circle</mat-icon>
              <mat-error *ngIf="showError('professionName')">{{ getErrorMessage('professionName') }}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Especialidade
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Selecione a especialidade médica. A lista é filtrada com base na profissão selecionada."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <mat-select formControlName="specialty" (selectionChange)="onSpecialtyChange()">
                <mat-option *ngFor="let specialty of getSpecialty()" [value]="specialty">{{ specialty }}</mat-option>
              </mat-select>
              <mat-icon matSuffix *ngIf="showSuccess('specialty')" class="success-icon">check_circle</mat-icon>
              <mat-error *ngIf="showError('specialty')">{{ getErrorMessage('specialty') }}</mat-error>
            </mat-form-field>
          </div>
          <div class="column">

            <div class="column-items">
              <mat-checkbox formControlName="adultCare">Atendimento Adulto</mat-checkbox>
              <mat-checkbox formControlName="pediatricCare">Atendimento Pediátrico</mat-checkbox>
              <mat-checkbox formControlName="serviceFormatOnLine">Serviço Online</mat-checkbox>
              <mat-checkbox formControlName="serviceFormatPresential">Serviço Presencial</mat-checkbox>
            </div>
          </div>
          <div class="column">
            <div *ngIf="showActivityAreas && getActivityArea().length > 0">
              <fieldset class="resource-fieldset">
                <legend>Áreas de Atuação:</legend>
                <div>
                  <div *ngFor="let area of getActivityArea()">
                    <div style="display: flex; align-items: center; gap: 16px;">
                      <mat-checkbox *ngIf="area != null && area != ''" [checked]="isAreaSelected(area)"
                        (change)="onAreaCheckboxChange($event, area)">{{ area }}</mat-checkbox>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

        </div>
      </div>

      <!-- Seção: Localização -->
      <div class="form-section">
        <h3>Localização</h3>

        <div class="multiColumns">
          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Estado
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Selecione o estado para filtrar as cidades disponíveis."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <mat-select formControlName="state">
                <mat-option value="">Selecione um estado</mat-option>
                <mat-option *ngFor="let state of states" [value]="state.code">
                  {{state.name}} ({{state.code}})
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>

        <div class="multiColumns">
          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Cidade de Referência
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Selecione a cidade central para a busca. Cidades próximas serão calculadas com base no raio especificado."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <mat-select formControlName="referenceCity">
                <mat-option value="">Selecione uma cidade</mat-option>
                <mat-option *ngFor="let city of cities" [value]="city.nome">
                  {{city.nome}}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="isLoading">Carregando cidades...</mat-hint>
            </mat-form-field>
          </div>

          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Raio (km)
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Defina o raio de busca em quilômetros. Valor mínimo: 0 km, Valor máximo: 500 km. Cidades dentro deste raio serão incluídas na busca."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <input matInput type="number" formControlName="radiusInKm">
              <mat-icon matSuffix *ngIf="showSuccess('radiusInKm')" class="success-icon">check_circle</mat-icon>
              <mat-error *ngIf="showError('radiusInKm')">{{ getErrorMessage('radiusInKm') }}</mat-error>
              <mat-hint *ngIf="!showError('radiusInKm')">Máximo: 500 km</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="nearbyCities.length > 0" class="nearby-cities">
          <app-city-chips-selector
            [availableCities]="nearbyCities"
            [selectedCities]="selectedCities"
            (selectionChange)="onCitySelectionChange($event)">
          </app-city-chips-selector>
        </div>
      </div>

      <!-- Seção: Detalhes do Serviço -->
      <div class="form-section">
        <h3>Detalhes do Serviço</h3>

        <div class="multiColumns">
          <div class="column">
            <div style="display: flex; gap: 10px; flex-wrap: wrap;">
              <mat-form-field appearance="outline" floatLabel="always" class="half-width">
                <mat-label>
                  Preço Mínimo
                  <mat-icon 
                    class="help-icon" 
                    matTooltip="Valor mínimo do serviço em reais. Deve ser menor ou igual ao preço máximo."
                    matTooltipPosition="right"
                    [matTooltipTouchGestures]="'on'">
                    help_outline
                  </mat-icon>
                </mat-label>
                <input matInput type="text" formControlName="amountMin" min="0"
                  appCurrencyMask autocomplete="off">
                <mat-icon matSuffix *ngIf="showSuccess('amountMin')" class="success-icon">check_circle</mat-icon>
                <mat-error *ngIf="showError('amountMin')">{{ getErrorMessage('amountMin') }}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always" class="half-width">
                <mat-label>
                  Preço Máximo
                  <mat-icon 
                    class="help-icon" 
                    matTooltip="Valor máximo do serviço em reais. Deve ser maior ou igual ao preço mínimo."
                    matTooltipPosition="right"
                    [matTooltipTouchGestures]="'on'">
                    help_outline
                  </mat-icon>
                </mat-label>
                <input matInput type="text" formControlName="amountMax" min="0"
                  appCurrencyMask autocomplete="off">
                <mat-icon matSuffix *ngIf="showSuccess('amountMax')" class="success-icon">check_circle</mat-icon>
                <mat-error *ngIf="showError('amountMax')">{{ getErrorMessage('amountMax') }}</mat-error>
              </mat-form-field>
            </div>
            <!-- Amount range error message -->
            <mat-error *ngIf="getAmountRangeError()" class="range-error">
              <mat-icon>error</mat-icon>
              {{ getAmountRangeError() }}
            </mat-error>
          </div>
          <div class="column">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>
                Unidade de Cobrança
                <mat-icon 
                  class="help-icon" 
                  matTooltip="Selecione como o serviço é cobrado (por hora, por consulta, por procedimento, etc.)."
                  matTooltipPosition="right"
                  [matTooltipTouchGestures]="'on'">
                  help_outline
                </mat-icon>
              </mat-label>
              <mat-select formControlName="billingUnit">
                <mat-option *ngFor="let unit of billingUnitEnum | keyvalue" [value]="unit.key">
                  {{ unit.value }}
                </mat-option>
              </mat-select>
              <mat-hint>Selecione a unidade de cobrança</mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="multiColumns">
          <div class="column">
            <mat-label>
              Disponibilidade
              <mat-icon 
                class="help-icon" 
                matTooltip="Selecione os períodos de disponibilidade desejados. Clique nos blocos para marcar/desmarcar dias e horários."
                matTooltipPosition="right"
                [matTooltipTouchGestures]="'on'">
                help_outline
              </mat-icon>
            </mat-label>
            <app-availability [availability]="availability" (availabilityChange)="onAvailabilityChange($event)"
              [editable]="true">
            </app-availability>
          </div>
          <div class="column">
            <mat-label>
              Disponibilidade Plantonista
              <mat-icon 
                class="help-icon" 
                matTooltip="Selecione os períodos de disponibilidade para atendimento de plantão/emergência."
                matTooltipPosition="right"
                [matTooltipTouchGestures]="'on'">
                help_outline
              </mat-icon>
            </mat-label>
            <app-availability [availability]="emergencyServiceAvailability"
              (availabilityChange)="onEmergencyAvailabilityChange($event)" [editable]="true">
            </app-availability>

          </div>
        </div>
      </div>

      <div class="footerButtons">
        <button mat-button type="button" (click)="resetForm()">
          Limpar
          <mat-icon>clear</mat-icon>
        </button>
        <button mat-flat-button color="primary" type="submit" [disabled]="!canSearch()" (click)="submitSearch()">
          Buscar
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </form>

    <div *ngIf="isLoading && !cities.length" class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Carregando...</p>
    </div>
  </div>

</div>

<!-- Results: use the reusable AdvancedSearchResultsComponent -->
<div *ngIf="resultTest && !editingMode">
  <!-- Cache indicator and actions -->
  <div class="results-header" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;flex-wrap:wrap;gap:8px;">
    <div *ngIf="isFromCache" class="cache-indicator" style="display:flex;align-items:center;gap:8px;color:var(--color-primary);font-size:14px;">
      <mat-icon style="font-size:20px;width:20px;height:20px;">cached</mat-icon>
      <span>Resultados em cache</span>
    </div>
    
    <!-- <div class="results-actions" style="display:flex;gap:8px;">
      <button mat-stroked-button color="primary" (click)="refreshSearch()" [disabled]="isLoading" matTooltip="Atualizar resultados ignorando cache">
        <mat-icon>refresh</mat-icon>
        Atualizar
      </button>
      <button mat-stroked-button color="primary" (click)="editingMode = true">
        <mat-icon>edit</mat-icon>
        Alterar pesquisa
      </button>
      <button mat-stroked-button color="primary" (click)="newSearch()">
        <mat-icon>search</mat-icon>
        Nova pesquisa
      </button>
    </div> -->
  </div>

  <app-advanced-search-service-results [items]="resultTest.content || []" [isLoading]="isLoading"
    [serverSide]="true" [length]="resultTest.page?.totalElements || 0" [pageSize]="pageSize"
    [searchConfig]="searchConfig" (page)="onPageChange($event)">
  </app-advanced-search-service-results>
</div>
}